module.exports = __webpack_public_path__ + "static/wadi-maka-2b8df355ca53aa600c62eac92891083f.png";